import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { fmtINR, fmtDate } from "../lib/format";
import { History as HistoryIcon } from "lucide-react";

export default function History() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, limit: 30 });
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);

  const load = useCallback(async () => {
    const { data } = await api.get(`/history?q=${encodeURIComponent(q)}&page=${page}&limit=30`);
    setData(data);
  }, [q, page]);
  useEffect(() => { load(); }, [load]);

  const pages = Math.max(1, Math.ceil(data.total / data.limit));

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-head text-2xl font-extrabold flex items-center gap-2"><HistoryIcon className="text-blue-700" /> Payment & Recharge Ledger</h1>
        <p className="text-slate-500 text-sm mt-1">Full chronological transaction history. Records are never overwritten.</p>
      </div>
      <input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search by reference / user…" className="h-9 px-3 rounded-lg border text-sm w-full max-w-sm" data-testid="history-search" />
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 border-b text-left text-[11px] uppercase text-slate-500">
            <th className="px-4 py-3">Date</th><th className="px-4 py-3">Customer</th><th className="px-4 py-3">Circuit</th><th className="px-4 py-3">ISP</th>
            <th className="px-4 py-3">Type</th><th className="px-4 py-3 text-right">Amount</th><th className="px-4 py-3">Method</th><th className="px-4 py-3">Reference</th><th className="px-4 py-3">By</th><th className="px-4 py-3">Late?</th></tr></thead>
          <tbody>
            {data.items.map((t) => (
              <tr key={t.id} className="border-b border-slate-100">
                <td className="px-4 py-3 font-mono-num text-xs">{fmtDate(t.recharge_date)}</td>
                <td className="px-4 py-3 font-semibold">{t.customer_name || "—"}</td>
                <td className="px-4 py-3 font-mono-num text-xs">{t.internal_circuit_id || "—"}</td>
                <td className="px-4 py-3">{t.vendor_name || "—"}</td>
                <td className="px-4 py-3"><span className="text-xs px-2 py-0.5 rounded bg-slate-100">{t.type === "invoice_payment" ? "Invoice Pay" : "Recharge"}</span></td>
                <td className="px-4 py-3 text-right font-mono-num font-semibold">{fmtINR(t.amount)}</td>
                <td className="px-4 py-3 text-xs">{t.payment_method || "—"}</td>
                <td className="px-4 py-3 font-mono-num text-xs">{t.reference_number || "—"}</td>
                <td className="px-4 py-3 text-xs">{t.user_name || "—"}</td>
                <td className="px-4 py-3">{t.was_late ? <span className="text-xs px-2 py-0.5 rounded bg-red-100 text-red-700">{t.days_late}d late</span> : <span className="text-xs text-emerald-600">on-time</span>}</td>
              </tr>
            ))}
            {data.items.length === 0 && <tr><td colSpan={10} className="px-4 py-10 text-center text-slate-400">No transactions.</td></tr>}
          </tbody>
        </table>
        <div className="flex items-center justify-between px-4 py-3 border-t text-sm">
          <span className="text-slate-500">{data.total} transactions</span>
          <div className="flex items-center gap-2">
            <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded-lg border disabled:opacity-40" data-testid="hist-prev">Prev</button>
            <span className="text-xs">Page {page}/{pages}</span>
            <button disabled={page >= pages} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded-lg border disabled:opacity-40" data-testid="hist-next">Next</button>
          </div>
        </div>
      </div>
    </div>
  );
}
